import React from "react";

const LeaderboardAvatar = ({ width = 40, height = 40, style = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 87.53 94.38"
      width={width}
      height={height}
      style={style}
    >
      <defs>
        <style>{`
          .cls-1 { fill: #fff; }
          .cls-2 { fill: #b68000; }
          .cls-3, .cls-4 { fill: none; }
          .cls-5 { clip-path: url(#clippath-1); }
          .cls-4 {
            stroke: url(#linear-gradient-2);
            stroke-miterlimit: 10;
            stroke-width: 2px;
          }
          .cls-6 { fill: url(#linear-gradient); }
          .cls-7 { clip-path: url(#clippath); }
        `}</style>

        <clipPath id="clippath">
          <path
            className="cls-3"
            d="M40.83,75.84l-27.32-27.32c-1.27-1.27-1.27-3.33,0-4.6l27.32-27.32c1.27-1.27,3.33-1.27,4.6,0l27.32,27.32c1.27,1.27,1.27,3.33,0,4.6l-27.32,27.32c-1.28,1.27-3.33,1.27-4.6,0Z"
          />
        </clipPath>

        <linearGradient
          id="linear-gradient"
          x1="293.12"
          y1="-220.55"
          x2="293.12"
          y2="-278.72"
          gradientTransform="translate(0 -4.85) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#350b31" />
          <stop offset=".44" stopColor="#250722" />
          <stop offset="1" stopColor="#0b010a" />
        </linearGradient>

        <clipPath id="clippath-1">
          <path
            className="cls-3"
            d="M23.82,23.66h38.64c1.8,0,3.25,1.46,3.25,3.25v38.64c0,1.8-1.46,3.25-3.25,3.25h-38.64c-1.8,0-3.25-1.46-3.25-3.25v-38.64c0-1.8,1.46-3.25,3.25-3.25Z"
          />
        </clipPath>

        <linearGradient
          id="linear-gradient-2"
          x1="293.13"
          y1="-205.38"
          x2="293.13"
          y2="-278.79"
          gradientTransform="translate(0 -4.85) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f6f2bc" />
          <stop offset=".42" stopColor="#f1b044" />
          <stop offset=".76" stopColor="#f6f2bc" />
          <stop offset="1" stopColor="#cd8b2a" />
        </linearGradient>
      </defs>

      <path
        className="cls-2"
        d="M40.44,80.83l-31.91-31.91c-1.48-1.48-1.48-3.89,0-5.37l31.91-31.91c1.48-1.48,3.89-1.48,5.37,0l31.91,31.91c1.48,1.48,1.48,3.89,0,5.37l-31.91,31.91c-1.48,1.48-3.89,1.48-5.37,0Z"
      />

      <g>
        <path
          className="cls-1"
          d="M40.83,75.84l-27.32-27.32c-1.27-1.27-1.27-3.33,0-4.6l27.32-27.32c1.27-1.27,3.33-1.27,4.6,0l27.32,27.32c1.27,1.27,1.27,3.33,0,4.6l-27.32,27.32c-1.28,1.27-3.33,1.27-4.6,0Z"
        />

        <g className="cls-7">
          <path
            className="cls-6"
            d="M43.12,44.86c5.57,0,10.08-4.51,10.08-10.08s-4.51-10.08-10.08-10.08-10.08,4.51-10.08,10.08c.01,5.57,4.52,10.08,10.08,10.08ZM48.7,44.87c-1.65.92-3.56,1.45-5.58,1.45s-3.92-.53-5.58-1.45c-5.69,2.23-9.73,7.76-9.73,14.25v23.75h30.62v-23.75c.01-6.49-4.03-12.02-9.73-14.25Z"
          />
        </g>
      </g>

      <path
        className="cls-4"
        d="M40.44,80.83l-31.91-31.91c-1.48-1.48-1.48-3.89,0-5.37l31.91-31.91c1.48-1.48,3.89-1.48,5.37,0l31.91,31.91c1.48,1.48,1.48,3.89,0,5.37l-31.91,31.91c-1.48,1.48-3.89,1.48-5.37,0Z"
      />
    </svg>
  );
};

export default LeaderboardAvatar;
